import { sendGA4Event } from 'services/analytics-events.service';

import { IErrorMessageParam, ILoadingTimeParam, IRNftParams, useEventParamsMethods } from './useEventsParams';

enum TopOffersEventName {
  Get = 'get_top_offers',
  Buy = 'buy_top_offers',
  BuySuccess = 'buy_top_offers_success',
  BuyError = 'buy_top_offers_error',
}

export const useTopOffersEvents = () => {
  const { withWalletAddressAndReferrer } = useEventParamsMethods();

  const sendTopOffersGetEvent = (params: ILoadingTimeParam) => {
    sendGA4Event(TopOffersEventName.Get, withWalletAddressAndReferrer(params));
  };

  const sendTopOffersBuyEvent = (params: IRNftParams) => {
    sendGA4Event(TopOffersEventName.Buy, withWalletAddressAndReferrer(params));
  };

  const sendTopOffersBuySuccessEvent = (params: IRNftParams) => {
    sendGA4Event(TopOffersEventName.BuySuccess, withWalletAddressAndReferrer(params));
  };

  const sendTopOffersBuyErrorEvent = (params: IRNftParams & IErrorMessageParam) => {
    sendGA4Event(TopOffersEventName.BuyError, withWalletAddressAndReferrer(params));
  };

  return {
    sendTopOffersGetEvent,
    sendBuyEvent: sendTopOffersBuyEvent,
    sendBuySuccessEvent: sendTopOffersBuySuccessEvent,
    sendBuyErrorEvent: sendTopOffersBuyErrorEvent,
  };
};
